import Decorator from './decorator'
import moment from 'moment'

export default class DriverDecorator extends Decorator {
  /**
   * Get the URL to the drivers thumbnail.
   *
   * @return string
   */
  thumbnailUrl () {
    if (this.decorated.photo_storage_path) {
      return `${this.decorated.photo_storage_path}/256x256.jpg?${moment().unix()}`
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/decorators/driver.js